// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as CardsSDK$OrcaPaymentPage from "./CardsSDK.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as VaultHelpers$OrcaPaymentPage from "./VaultHelpers.bs.js";

function PaymentMethodsSDK(props) {
  var sessions = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.sessions);
  var setVaultCredentials = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.vaultCredentials);
  var isSavedCardCvcFlow = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.isSavedCardCvcFlow);
  React.useEffect((function () {
          setVaultCredentials(function (param) {
                return VaultHelpers$OrcaPaymentPage.getVaultCredentialsFromSessions(sessions);
              });
        }), [sessions]);
  return React.createElement("div", {
              style: {
                padding: "2px"
              }
            }, React.createElement(CardsSDK$OrcaPaymentPage.make, {
                  cvcOnly: isSavedCardCvcFlow
                }));
}

var make = PaymentMethodsSDK;

export {
  make ,
}
/* jotai Not a pure module */
